export default "__VITE_ASSET__Dl8nPE27__"